import { apiClient } from "helpers/api_helper";


export const updateSubCategory = async (data: object) => {
    try {
        const response = await apiClient.post('/api/v1/Category/UpdateSubCategory', data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const getSubCategoryById = async (id: any) => {
    try {
        const response = await apiClient.get(`/api/v1/Category/GetSubCategoryDetailsById?id=${id}`);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
};

export const GetAllSubCategory = async (data: object) => {
    try {
        const response = await apiClient.get(`/api/v1/Category/GetAllSubCategory`, data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const CreateSubCategory = async (data: object) => {
    try {
        const response = await apiClient.post('/api/v1/Category/InsertSubCategory', data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};


export const GetCategorySelectList = async () => {
    try {
        const response = await apiClient.get(`/api/v1/Category/GetCategorySelectList`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const DeleteSubCategory = async (id: any) => {
    try {
        const response = await apiClient.delete(`/api/v1/Category/DeleteSubCategory?id=${id}`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};
